var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlan3D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 90,
    viewBox: "0 0 60 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5613 82.2C26.4413 82.248 27.1093 82.488 27.5653 82.92C28.0293 83.344 28.2613 83.9 28.2613 84.588C28.2613 85.068 28.1453 85.496 27.9133 85.872C27.6813 86.24 27.3373 86.532 26.8813 86.748C26.4253 86.964 25.8693 87.072 25.2133 87.072C24.6053 87.072 24.0293 86.976 23.4853 86.784C22.9493 86.584 22.5173 86.32 22.1893 85.992L22.6093 85.308C22.8893 85.596 23.2613 85.832 23.7253 86.016C24.1893 86.192 24.6853 86.28 25.2133 86.28C25.9013 86.28 26.4333 86.132 26.8093 85.836C27.1853 85.532 27.3733 85.116 27.3733 84.588C27.3733 84.068 27.1853 83.66 26.8093 83.364C26.4333 83.068 25.8653 82.92 25.1053 82.92H24.5053V82.284L26.8333 79.368H22.5373V78.6H27.9373V79.212L25.5613 82.2ZM30.3727 78.6H33.7927C34.6807 78.6 35.4647 78.78 36.1447 79.14C36.8247 79.492 37.3527 79.988 37.7287 80.628C38.1047 81.26 38.2927 81.984 38.2927 82.8C38.2927 83.616 38.1047 84.344 37.7287 84.984C37.3527 85.616 36.8247 86.112 36.1447 86.472C35.4647 86.824 34.6807 87 33.7927 87H30.3727V78.6ZM33.7447 86.232C34.4807 86.232 35.1247 86.088 35.6767 85.8C36.2287 85.504 36.6567 85.1 36.9607 84.588C37.2647 84.068 37.4167 83.472 37.4167 82.8C37.4167 82.128 37.2647 81.536 36.9607 81.024C36.6567 80.504 36.2287 80.1 35.6767 79.812C35.1247 79.516 34.4807 79.368 33.7447 79.368H31.2607V86.232H33.7447Z",
    fill: "#2196F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9997 56.0282C44.3745 56.0282 56.0277 44.375 56.0277 30.0002C56.0277 15.6253 44.3745 3.97217 29.9997 3.97217C15.6248 3.97217 3.97168 15.6253 3.97168 30.0002C3.97168 44.375 15.6248 56.0282 29.9997 56.0282Z",
    stroke: "#2196F3",
    strokeWidth: 2.7,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0004 50.9998L12.3574 41.0278V19.2388L30.0004 29.4388V50.9998Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30 50.9998L47.643 41.0278V19.2388L30 29.4388V50.9998Z",
    fill: "#757575"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0004 29.454L12.3574 19.239L30.0004 9L47.6434 19.239L30.0004 29.454Z",
    fill: "#2196F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlan3D);
export default __webpack_public_path__ + "static/media/plan-3d.2313053064e26f5b02a8cd1b7afdbeb2.svg";
export { ForwardRef as ReactComponent };